import { useMenuContext } from 'context/menu-context'
import { MenuList } from './styled'

export const Menu = () => {
  const { chapters, scrollToElement } = useMenuContext()

  return (
    <MenuList>
      {chapters.map(chapter => {
        const isActive = !!chapter.sections.find(s => s.isActive)

        const handleClick = () => scrollToElement(chapter.sections[0]?.element)

        return (
          <li data-current={isActive} key={chapter.title}>
            <button type="button" onClick={handleClick}>
              {chapter.title}
            </button>
          </li>
        )
      })}
    </MenuList>
  )
}
